//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import VdoCipherComp from "../../Components/VdoCipher/VdoCipher";
import { Link } from "react-router-dom";
import PipeDriveEmbed from "../../Pages/PipeDrive/PipeDriveEmbed";

const ArazonaContent: React.FC = () => {
  return (
    <div id="Goals" className="sectionContainer">
      <SecHeader title="The Show" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            This successful trade show featured an exclusive deep-dive panel
            with the CEO of ICE GEMS, where he discusses in great detail the
            advantages of our revolutionary technology.
          </p>{" "}
        </div>
      </SubSection>
      {/* <SecHeader title="The Panel" /> */}
      {/* <SubSection>
                <VdoCipherComp filename="eta4k"/>
            </SubSection> */}
      <SecHeader title="Contact Us" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            We would like to hear more from you. Please reach out through our{" "}
            <Link to="../request-info">Request Info</Link> page. If you have not
            already done so, please create a{" "}
            <Link to="../user-login">user profile</Link> so we can further
            assist you in your inquiries.
          </p>{" "}
        </div>
      </SubSection>

      {/* <PipeDriveEmbed index={0} /> */}
      <SecHeader title="More Information" />
      <SubSection isSplit={false}>
        <div className="description-container">
          <p>
            Here is some additional information and links about us and the trade
            show. Please feel free to reach out to us with any questions you may
            have, and we hope to see you at the event!
            <ul>
              <li>
                <Link to="/register">Register</Link>
              </li>
              <li>
                <Link to="/espec">ESPEC Calculator</Link>
              </li>
              <li>
                <Link to="/ourStory">About Us</Link>
              </li>
              <li>
                <Link to="/request-info">Contact Information</Link>
              </li>
            </ul>
          </p>{" "}
        </div>
      </SubSection>
    </div>
  );
};

export default ArazonaContent;
